import React from "react";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const navigationLinks = [{
    label: "U.S. Market",
    href: "/TheCarefulConsultingPage"
  }, {
    label: "About Us",
    href: "#"
  }, {
    label: "Our Approach",
    href: "#"
  }, {
    label: "Contact",
    href: "#"
  }];
  const regionLinks = [{
    label: "North America",
    href: "#"
  }, {
    label: "Europe",
    href: "#"
  }, {
    label: "Asia Pacific",
    href: "#"
  }, {
    label: "Middle East & Africa",
    href: "#"
  }];
  const serviceLinks = [{
    label: "Global Expansion Strategy",
    href: "#"
  }, {
    label: "Corporate Strategy Development",
    href: "#"
  }, {
    label: "Growth Advisory",
    href: "#"
  }, {
    label: "Supply Chain Optimization",
    href: "#"
  }, {
    label: "Brand Matching",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }, {
    label: "Legal Notice",
    href: "#"
  }];
  return;
}